"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconAttention = function SvgIconAttention(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "attention icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Attention Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.732 42.889h34.537c2.06 0 3.376-2.192 2.406-4.005l-17.27-32.33c-1.026-1.924-3.785-1.924-4.813 0L4.324 38.883c-.968 1.813.349 4.005 2.408 4.005zm14.542-24.504h5.452v10.89h-5.452zM24 31.998a2.726 2.726 0 012.726 2.723A2.726 2.726 0 0124 37.444a2.726 2.726 0 01-2.726-2.723A2.726 2.726 0 0124 31.998z"
  }));
};

var _default = SvgIconAttention;
exports.default = _default;